<template>
  <div class="h-user-head">
    <img :src="userInfo.avatar" />
    <template v-if="$store.getters.isLogin">
      <span>{{ userInfo.nickname }}</span>
      <Logout v-if="logout" />
    </template>
    <span
      v-else
      href="javascript:;"
      @click="$store.commit('app/setLoginPop', true)"
      >当前未登录账号</span
    >
  </div>
</template>
<script>
import Logout from '~/components/logic-common/Logout'
export default {
  components: { Logout },
  props: {
    logout: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  }
}
</script>
